export default "__VITE_ASSET__XQ2FP_AE__"